import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><circle stroke="currentcolor" transform="translate(8 8)" r="7"/></svg>`;

export { symbol as default };
